/** The analyst's chosen next status/phase when saving on exit. */
export interface ExitSelection {
  approvalId: string;
  nextStatus: string;
  nextPhase: string;
}

/**
 * Placeholder for persisting the analyst's exit selection (the next
 * status/phase the account should move to). The step6 BFF client currently
 * exposes only the options *read* (`getNextStatusPhases`) — there is no
 * mutation to persist the transition yet — so this is intentionally a no-op.
 * Keeping it as a named, typed seam lets the Save & Exit flow (release the VLA
 * lock, then navigate away) be wired end to end today, and gives the real
 * request one obvious place to land later.
 *
 * TODO(OR-20985): call the real exit / status-change endpoint once the BFF
 * exposes it, and surface success/failure to the caller.
 * @param {ExitSelection} selection - The chosen next status/phase for the deal.
 * @returns {Promise<void>} Resolves once the (currently stubbed) save settles.
 */
export function saveExitSelection(selection: ExitSelection): Promise<void> {
  void selection;
  return Promise.resolve();
}
